import AdvancedSearchFiltersComponent from './AdvancedSearchFilters/AdvancedSearchFilters'
import AdvancedSearchToggleButtonComponent from './AdvancedSearchToggleButton/AdvancedSearchToggleButton'
import PersonCardComponent from './PersonCard/PersonCard'
import SearchCardComponent from './SearchCard/SearchCard'
import ResultsBarComponent from './ResultsBar/ResultsBar'
import ResultsInfoComponent from './ResultsInfo/ResultsInfo'
import ResultsPerPageSelectorComponent from './ResultsPerPageSelector/ResultsPerPageSelector'
import SearchBoxComponent from './SearchBox/SearchBox'
import SearchBox2Component from './SearchBox2/SearchBox2'
import SubclientDropdownComponent from './SubclientDropdown/SubclientDropdown'
import SideBarMenuComponent from './SideBarMenu/SideBarMenu'

export const AdvancedSearchFilters = AdvancedSearchFiltersComponent
export const AdvancedSearchToggleButton = AdvancedSearchToggleButtonComponent
export const PersonCard = PersonCardComponent
export const SearchCard = SearchCardComponent
export const ResultsBar = ResultsBarComponent
export const ResultsInfo = ResultsInfoComponent
export const ResultsPerPageSelector = ResultsPerPageSelectorComponent
export const SearchBox = SearchBoxComponent
export const SearchBox2 = SearchBox2Component
export const SubclientDropdown = SubclientDropdownComponent
export const SideBarMenu = SideBarMenuComponent
